import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";

import AuthLayout from "./components/portal/AuthLayout";
import PortalLayout from "./components/portal/PortalLayout";

import "./assets/css/variable.css";
import "./App.css";
import { AppRoute, authProtectedRoutes, publicRoutes } from "./routes/route";
import Error404 from "./pages/Utility/Error404";
import { responsiveWidth } from "./store/actions";
class App extends Component {
	constructor(props) {
		super(props);
		this.state = {};

	}

	componentDidMount() {
		window.addEventListener("unload", () => {
			localStorage.setItem("lastOpen", new Date());
		});

		const handleResize = () => {
			this.props.responsiveWidth(window.innerWidth); // Update state when window resizes
		};
		window.addEventListener("resize", handleResize);

		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = 'https://cdn.jsdelivr.net/npm/remixicon/fonts/remixicon.css';
		document.head.appendChild(link);

		// Clear reload flag on page load
		window.addEventListener("load", () => {
			let isRemember = localStorage.getItem("remember")
			if (isRemember === 'false' || isRemember === false) {
				let lastOpen = localStorage.getItem("lastOpen");
				let comparedTime = new Date() - new Date(lastOpen);

				if (comparedTime > 7 * 24 * 60 * 60 * 1000) { // 7 days in milliseconds
					localStorage.removeItem("token");
					localStorage.removeItem("lastOpen");
					sessionStorage.removeItem("token");
					window.location.href = "/login";
				}
			}
		});
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	render() {
		return (
			<React.Fragment>
				<Routes basename={"/"}>
					{publicRoutes.map((route, idx) => (
						<Route
							path={route.path}
							element={<AuthLayout>{route.component}</AuthLayout>}
							key={idx}
							exact={true}
						/>
					))}

					{authProtectedRoutes.map((route, idx) => (
						<Route
							key={idx}
							path={route.path}
							element={
								<AppRoute requiredPermission={route.requiredPermission}>
									<PortalLayout>{route.component}</PortalLayout>
								</AppRoute>
							}
						/>
					))}

					<Route path="*" element={<Error404 />} />
				</Routes>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		layout: state.Layout
	};
};


export default connect(mapStateToProps, { responsiveWidth })(App);
